import { Stack, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';

import { IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../../../../../shared/components/UI/Button/Button';

import { useDeleteVaultPropertyMutation } from '../../../hooks/vaultProperty.hook';

export function VaultPropertyDeleteSection({
  vaultPropertyId,
  onDelete,
}: {
  vaultPropertyId: number;
  onDelete: () => void;
}) {
  const { t } = useTranslation(['bidResponse']);
  const { mutate: deleteVaultProperty } = useDeleteVaultPropertyMutation();

  const displaySuccessNotification = () => {
    notifications.show({
      message: t(
        'vault.sidepanels.updateProperty.deleteProperty.successMessage',
      ),
      color: 'green',
    });
  };

  const handleDelete = () => {
    modals.openContextModal({
      modal: 'vaultPropertyDelete',
      innerProps: {
        onDelete: () => {
          deleteVaultProperty(vaultPropertyId, {
            onSuccess: () => {
              displaySuccessNotification();
              onDelete();
            },
          });
        },
      },
    });
  };

  return (
    <Stack spacing="03">
      <Stack spacing={0}>
        <Text fw="400">
          {t('vault.sidepanels.updateProperty.deleteProperty.title')}
        </Text>
        <Text variant="sm" c="gray.7">
          {t('vault.sidepanels.updateProperty.deleteProperty.description')}
        </Text>
      </Stack>
      <Button
        onClick={handleDelete}
        leftIcon={<IconTrash size={18} />}
        maw="25%"
        miw="200px"
        size="md"
        color="red"
      >
        {t('vault.sidepanels.updateProperty.deleteProperty.deleteProperty')}
      </Button>
    </Stack>
  );
}
